export const schema = {
  id: 'ground-source-heat-pump-service-maintenance',
  name: 'Ground Source Heat Pump & Cylinder Service/Maintenance Checklist',
  description: 'Service and maintenance checklist for ground source heat pumps and hot water cylinders',
  category: 'HVAC / Renewables',
  sections: [
    {
      id: 'business',
      title: 'Details of Registered Business',
      fields: [
        { id: 'businessName', label: 'Business Name', type: 'text', required: true },
        { id: 'businessAddress', label: 'Business Address', type: 'textarea', required: true },
        { id: 'businessTel', label: 'Business Tel. No', type: 'tel', required: true }
      ]
    },
    {
      id: 'jobAddress',
      title: 'Job Address',
      fields: [
        { id: 'jobName', label: 'Name', type: 'text', required: true },
        { id: 'jobAddress', label: 'Address', type: 'textarea', required: true },
        { id: 'jobTel', label: 'Tel. No', type: 'tel', required: true }
      ]
    },
    {
      id: 'landlordAgent',
      title: 'Landlord/Agent Address',
      fields: [
        { id: 'landlordName', label: 'Name', type: 'text' },
        { id: 'landlordAddress', label: 'Address', type: 'textarea' },
        { id: 'landlordTel', label: 'Tel. No', type: 'tel' }
      ]
    },
    {
      id: 'heatPump',
      title: 'Ground Source Heat Pump Details',
      fields: [
        { id: 'make', label: 'Make', type: 'text', required: true },
        { id: 'model', label: 'Model', type: 'text', required: true },
        { id: 'serialNumber', label: 'Serial No.', type: 'text', required: true },
        { id: 'location', label: 'Location', type: 'text', required: true },
        { id: 'compressorCurrentAmps', label: 'Compressor Running Current (A)', type: 'number' },
        { id: 'sightGlassClear', label: 'Sight Glass Moisture Indicator', type: 'select', options: ['Clear / Dry (Green)', 'Moisture Indicated (Yellow)', 'N/A'], required: true }
      ]
    },
    {
      id: 'groundLoop',
      title: 'Ground Loop (Brine Circuit) Checks',
      fields: [
        { id: 'collectorType', label: 'Collector Type', type: 'select', options: ['Borehole (Vertical)', 'Horizontal Slinky / Trenches', 'Open Loop Water Well', 'Lake / Pond Array'], required: true },
        { id: 'brinePressureBar', label: 'Brine System Operating Pressure (Bar)', type: 'number', required: true },
        { id: 'glycolFreezePoint', label: 'Glycol Freeze Protection Point (°C)', type: 'text', required: true },
        { id: 'brineDeltaTC', label: 'Brine Flow & Return Delta T (°C)', type: 'number', required: true },
        { id: 'strainerCleaned', label: 'Ground Loop Strainer/Filter Cleaned?', type: 'select', options: ['Yes', 'No', 'N/A'], required: true }
      ]
    },
    {
      id: 'vesselDetails',
      title: 'Details of Hot Water Storage Vessel',
      fields: [
        { id: 'make', label: 'Make', type: 'text', required: true },
        { id: 'model', label: 'Model', type: 'text', required: true },
        { id: 'location', label: 'Location', type: 'text', required: true },
        { id: 'capacity', label: 'Capacity (L)', type: 'number', required: true },
        { id: 'makersWarningLabel', label: 'Is Makers warning label attached?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'scaleReducerFitted', label: 'Has a scale reducer been fitted?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'immersionTested', label: 'Immersion heater operation verified?', type: 'select', options: ['Yes', 'No', 'N/A'], required: true }
      ]
    },
    {
      id: 'operatingDetails',
      title: 'Heating Circuit & Safety Relinquishment',
      fields: [
        { id: 'systemOperatingPressure', label: 'System operating pressure (Bar)', type: 'number', required: true },
        { id: 'operatingPressureExpansionVessel', label: 'Operating pressure of expansion vessel (Bar)', type: 'number', required: true },
        { id: 'prvLiftTest', label: 'Pressure Relief Valve (PRV) Lift Test Satisfactory?', type: 'select', options: ['Pass / Operating Correctly', 'Failed / Leaking', 'N/A'], required: true },
        { id: 'dischargeCompliant', label: 'Discharge pipework D1/D2 and tundish compliant with G3?', type: 'select', options: ['Compliant (Continuous fall)', 'Defective', 'N/A'], required: true }
      ]
    },
    {
      id: 'defects',
      title: 'Defect(s) Identified',
      fields: [
        { id: 'defectsIdentified', label: 'Defect(s) Identified', type: 'textarea' }
      ]
    },
    {
      id: 'workCarriedOut',
      title: 'Work Carried Out',
      fields: [
        { id: 'workCarriedOut', label: 'Work Carried Out', type: 'textarea', required: true }
      ]
    },
    {
      id: 'receivedBy',
      title: 'Received By',
      fields: [
        { id: 'receivedByName', label: 'Print Name', type: 'text', required: true },
        { id: 'receivedByDate', label: 'Date', type: 'date', required: true }
      ]
    },
    {
      id: 'issuedBy',
      title: 'Issued By',
      fields: [
        { id: 'issuedByName', label: 'Print Name', type: 'text', required: true },
        { id: 'engineerSignature', label: 'Signature', type: 'signature', required: true },
        { id: 'issuedByDate', label: 'Date', type: 'date', required: true }
      ]
    }
  ]
};

export default schema;
